export default function StickyLineButton() {
  return (
    <a
      href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#06C755] hover:bg-[#05b34c] rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer group"
      aria-label="LINE友達追加"
    >
      <i className="ri-line-fill text-3xl text-white"></i>
      <div className="absolute right-full mr-4 bg-black/90 text-white text-sm font-bold px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        LINEで相談する
      </div>
    </a>
  );
}